import React from 'react';
import { Row, Col } from '../../../themes/MoGrid';
import Text from '../../common/Text/Text';
import { Hidden } from '@material-ui/core';
import helper from '../../utils/helper';
import { Container, Image, ImageContainer, VideoContainer, Picture, VideoIcon, ImageInfo } from './Gallery.style';

const Gallery = ({ cms, gallery }) => {
    const [selecting, setSelecting] = React.useState({type:'image', credit:'', caption:'', alt:''});
    const [isVideoPlaying, setIsVideoPlaying] = React.useState(helper.getUrlParam('autoplay') === '1' ? true : false);
    
    React.useEffect(() => {
        if(gallery.length > 0){
            setSelecting(gallery[0]);
        }
    }, [gallery])

    return ( 
        <Container>
            <Row>
                <Col xs={12} sm={8}>
                    <Image>
                        <Hidden smUp>
                            <ImageInfo>
                                <Text level="small">{cms.snippets['text-common-image-by'].text} {selecting.credit}</Text>
                            </ImageInfo>
                        </Hidden>
                        <ImageContainer>
                            {isVideoPlaying ?
                                <VideoContainer src={selecting.videoURL.replace('/watch?v=','/embed/') + '?autoplay=1'} allow='autoplay'/>
                                :<React.Fragment>
                                    <Picture>{helper.renderImage(selecting)}</Picture>
                                    { selecting.type === 'video' &&
                                        <VideoIcon className="fas fa-play" isOnSelecting={true} onClick={() => setIsVideoPlaying(true)}/>
                                    }
                                </React.Fragment>
                            }
                        </ImageContainer>
                      
                        <ImageInfo>
                            <Text level="small">{selecting.caption}</Text>
                            <Hidden xsDown>
                                <Text level="small">{cms.snippets['text-common-image-by'].text} {selecting.credit}</Text>
                            </Hidden>
                        </ImageInfo>
                    </Image>
                </Col>
               
                <Hidden xsDown>
                    <Col sm={4}>
                        <Row>
                            {gallery.map((item, i) => 
                                <Col sm={6} key={i}>
                                    <ImageContainer isSideGallery={true} isNotSelecting={item !== selecting} isVideo={item.type === 'video'} 
                                        onClick={() => {setIsVideoPlaying(false); setSelecting(item);}}>
                                        <Picture>{helper.renderImage(item, 'small')} </Picture>
                                        { item.type === 'video' && 
                                            <VideoIcon className="fas fa-play" />
                                        }
                                    </ImageContainer>
                                </Col>
                            )}
                        </Row>
                    </Col>
                </Hidden>
            </Row>
        </Container>
     );
}
 
export default Gallery;